import React from 'react';
import { AtsLinkItemProps } from './ats-item.interfaces';
import { ExternalLinkItem } from './ExternalLinkItem';

export const LinkItem = React.forwardRef<HTMLAnchorElement, AtsLinkItemProps>(({ item, pattern, ...rest }, ref) => {
  if (item.params === null) {
    throw new Error('Asset has no params: ' + item.name);
  }

  if (item.params.providerIdentifier) {
    return <ExternalLinkItem {...rest} item={item} pattern={pattern} ref={ref} />;
  }

  return (
    <a {...rest} href={item.params.url} ref={ref}>
      {rest.children}
    </a>
  );
});
